// SPDX-License-Identifier: Apache-2.0
// File: src/App.tsx
import React from 'react';
import { MainPerformanceView } from './ui/components/MainPerformanceView';

export const App: React.FC = () => {
  return <MainPerformanceView />;
};

export default App;
